import { ReactElement } from 'react'
import styles from './WebImpressumScreen.module.scss'
import { DesktopBodyLarge, DesktopHeadlineLarge, DesktopTitleLarge } from '../../Typography'

export const WebImpressumScreen = (): ReactElement => {
  return (
    <div className={styles.container}>
      <DesktopHeadlineLarge>Impressum</DesktopHeadlineLarge>
      <div className={styles.gaplessBox}>
        <DesktopBodyLarge>FIGHTBACK Wrestling</DesktopBodyLarge>
        <DesktopBodyLarge>c/o German Hurricane Wrestling e. V.</DesktopBodyLarge>
        <DesktopBodyLarge>Goethestraße 13A</DesktopBodyLarge>
        <DesktopBodyLarge>64569 Nauheim</DesktopBodyLarge>
      </div>
      <div className={styles.gaplessBox}>
        <DesktopBodyLarge fontWeight={700}>Vertreten durch:</DesktopBodyLarge>
        <DesktopBodyLarge>Aaron Krauser, Maurizio Bisignano, Sascha Döberin</DesktopBodyLarge>
      </div>
      <DesktopTitleLarge>Kontakt</DesktopTitleLarge>
      <div className={styles.gaplessBox}>
        <DesktopBodyLarge>+49 176 32646683</DesktopBodyLarge>
        <DesktopBodyLarge>office@fightback-wrestling.com</DesktopBodyLarge>
      </div>
      <DesktopTitleLarge>Rechtlich verantwortlich</DesktopTitleLarge>
      <DesktopBodyLarge>Aaron Krauser, Sascha Döberin</DesktopBodyLarge>
      <DesktopTitleLarge>Verbraucherstreitbeilegung/Universalschlichtungsstelle</DesktopTitleLarge>
      <DesktopBodyLarge>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </DesktopBodyLarge>
    </div>
  )
}
